import Rete, { Socket} from "rete";
import VueNumberControl from "./NumberControl.vue";
import AnyTypeSocket from "../../Utils/CommonSockets";

export class NumberControl extends Rete.Control {
  constructor(emitter, key, readonly) {
    super(key);
    this.render = "vue";
    this.component = VueNumberControl;
    this.props = { emitter, ikey: key, readonly };
  }

  setValue(val) {
    this.vueContext.value = val;
  }
  
}

const NumberSocket = new Socket("Number");
NumberSocket.combineWith(AnyTypeSocket);

export { NumberSocket };
